import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Loader from '../../Loader';

class PriceSlider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			slider: this.props.steps
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSliderChange = this.handleSliderChange.bind(this);
	}

	componentDidMount() {
		// initialise the price slider
		window.$('#myRange').bind("slider:changed", this.handleChange.bind(this))

	}

	render() {
		if (this.props.advicePrice) {

			// create an array with possible steps
			var frameAdvicePrice = parseInt(this.props.advicePrice, 10);
			var min = parseInt(this.props.min, 10);
			var max = parseInt(this.props.max, 10);
			var steps = parseInt(this.props.steps, 10);
			var framePriceSteps = [min];
			var lowStep = frameAdvicePrice / steps;
			var highStep = (max - frameAdvicePrice) / steps;
			var step = lowStep;

			for (let i = 0; i < steps; i++) {
				if (step < min) {
					step = min;
				}
				if (step > frameAdvicePrice) {
					step = frameAdvicePrice;
				}
				framePriceSteps.push(Math.round(step / 100) * 100);
				step = step + lowStep;

			}
			step = frameAdvicePrice + highStep;
			for (let i = 0; i < steps; i++) {
				if (step > max) {
					step = max;
				}
				framePriceSteps.push(Math.round(step / 100) * 100);
				step = step + highStep;
			}

			return (
				<div className="col-12">
					<div className="row">

						<link href="/css/simple-slider.css" rel="stylesheet" type="text/css" />

						<div className="col-12 text-center">
							<div id="demo">{framePriceSteps[this.state.slider] ? framePriceSteps[this.state.slider] : '0'}</div>
						</div>
						<div className="col-12">
							<div className="row">
								<div className="slidecontainer col-12">

									<input id="price-slider" className="slider" min="0" max="200" type="range" list="tickmarks" onChange={this.handleSliderChange} />

								</div>
								<div className="col-4 text-left">
									{this.props.t('PriceSlider_Voordelig')}
								</div>
								<div className="col-4 text-center">
									{this.props.t('PriceSlider_Advies')}
								</div>
								<div className="col-4 text-right">
									{this.props.t('PriceSlider_High-End')}
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return <Loader />;
		}
	}
	handleChange(event, data) {
		window.$('#demo').html(data.value);
		this.setState({ value: data.value });
	}
	handleSliderChange(event) {
		this.setState({ slider: event.target.value }, () => {
			var price = window.$('#demo').html();
			this.props.handle(price);
		});
	}
}

export default withTranslation('price')(PriceSlider);
